export const getElementsToRemove = (changes, elements) => {
  const removeChanges = changes.filter((change) => change.type === 'remove');
  return removeChanges.map((change) => elements.find((node) => node.id === change.id));
};
